module.exports = __webpack_public_path__ + "img/gradient-triangle.63360ff3.svg";